import React from 'react'
import LabeledValue from '../common/LabeledValue'
import {Link} from 'react-router-dom'
import {formatAmount, formatDate, formatDateString} from '../../services/utils'
import {BillingActivity, Reservation} from '../../types/app-types'
import {getNavigationPaths} from '../../services/navigation'
import LoaderInline from '../common/LoaderInline'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faCircleInfo} from '@fortawesome/free-solid-svg-icons'

interface AccountLatestStatementCardProps {
  accountId: string
  billingActivityQuery: {
    data?: BillingActivity
    isLoading: boolean
  }
  reservation: Reservation
  className?: string
}

const AccountBalanceCard = ({
  accountId,
  billingActivityQuery,
  reservation,
  className = ''
}: AccountLatestStatementCardProps) => {
  const paths = getNavigationPaths(accountId)
  const isLoading = billingActivityQuery.isLoading
  const statementBalance = billingActivityQuery.data?.statementCurrentBalance
  const currentBalance =
    reservation.status === 'CheckedOut'
      ? !isNaN(reservation?.balance?.amount)
        ? Math.abs(reservation?.balance?.amount)
        : null
      : billingActivityQuery.data?.pendingBalance || 0
  const todaysDate = formatDate(new Date())
  const billingPeriodDueDate = billingActivityQuery.data?.dueDate
    ? formatDateString(billingActivityQuery.data?.dueDate)
    : 'Unknown'
  const billingPeriodDate = billingActivityQuery.data?.date
    ? formatDateString(billingActivityQuery.data?.date)
    : ''
  const isFutureMoveIn = billingActivityQuery.data?.isFutureMoveIn

  return (
    <div className={className}>
      <div className="card-default h-full">
        <div className="card-body-default">
          <div className="flex-grow">
            <h1 className="card-header">Billing Summary</h1>

            {isLoading ? <LoaderInline /> : ''}

            {!isLoading ? (
              <>
                <LabeledValue
                  value={formatAmount(currentBalance)}
                  valueStyles="font-bold"
                  label={`Current Balance (as of ${todaysDate})`}
                />
                {statementBalance && !isFutureMoveIn ? (
                  <LabeledValue
                    value={formatAmount(statementBalance)}
                    valueStyles="font-bold"
                    label={`Last Billing Period Balance (as of ${billingPeriodDate})`}
                  />
                ) : (
                  ''
                )}
                <LabeledValue
                  value={billingPeriodDueDate}
                  valueStyles="font-bold"
                  label="Pay by Date"
                />
                <div className="text-sm my-6">
                  <FontAwesomeIcon icon={faCircleInfo} className="mr-1" />
                  Please pay the{' '}
                  {statementBalance && !isFutureMoveIn
                    ? 'last billing period'
                    : 'current'}{' '}
                  balance by {billingPeriodDueDate}.
                </div>
              </>
            ) : (
              ''
            )}
          </div>
          <div className="card-actions flex-none h-8">
            {!isLoading ? (
              <>
                <Link
                  to={`${paths.MakePayment}?amount=${currentBalance}`}
                  className="link link-primary text-sm"
                >
                  Pay Balance
                </Link>
                <Link to={paths.Billing} className="link link-primary text-sm">
                  View Billing
                </Link>
              </>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default AccountBalanceCard
